export const MARKETING_TEXT = {
  title: 'Marketing Cookies',
  description: 'These cookies help us show you relevant ads.',
};
